import { render, staticRenderFns } from "./tabBarLayout.vue?vue&type=template&id=09b40e14"
import script from "./tabBarLayout.vue?vue&type=script&lang=js"
export * from "./tabBarLayout.vue?vue&type=script&lang=js"
import style0 from "./tabBarLayout.vue?vue&type=style&index=0&id=09b40e14&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports